<script>
  import relatorioServico from '../relatorio.servico';
  import projetoServico from '~modulos/projeto/servico';

  import 'select2';
  import 'select2/dist/js/i18n/pt-BR';
  import 'vue-strap/dist/vue-strap-lang'; 

  import { datepicker } from 'vue-strap';
  import { checkbox } from 'vue-strap';
  import CabecalhoRelatorio from '~componentes/CabecalhoRelatorio.vue';
  import TelaCheia from '~componentes/TelaCheia.vue';

  export default {
    components: { datepicker, CabecalhoRelatorio, TelaCheia, checkbox },
    data() {
      return {
        filtros: {
          idProjeto: '0',
          idGrupo: '',
          idRubrica: '0',
          idSubrubrica: '',
          dataInicio: moment(new Date()).format('DD/MM/YYYY'),
          dataFim: moment(new Date()).format('DD/MM/YYYY'),
        },
        projetos: [],
        rubricas: [],
        subrubricas: [],
        relatorio: [],  
        grupos: [],
        
        configuracao: this.$storage.configuracao(),
        dataInicio: '',
        dataFim: '',

        projeto: null,
        grupo: null,
        rubrica: null,
        subrubrica: null,
      }
    },
    methods: {
      listaDeProjetos() {
        return projetoServico
          .listaDeProjetosPermissao("RelLancamentoFinanceiroProjeto")
          .then(projetos => {
            this.projetos = projetos;
          });
      },
      listaDeGrupos() {
        return projetoServico
          .listaDeGrupos()
          .then(grupos => {
            this.grupos = grupos;
          });
      },
      listaDeRubricas() {
        return projetoServico
          .listaRubricasLancamento(this.filtros.idProjeto)
          .then(rubricas => {
            this.rubricas = rubricas;
          });
      },
      listaDeSubrubricas() {
        this.filtros.idSubrubrica = '';

        return projetoServico
          .listaSubRubricasLancamento(this.filtros.idProjeto, this.filtros.idRubrica)
          .then(subrubricas => {
            this.subrubricas = subrubricas;
          });
      },
      gerar() {
        this.relatorio = {};
        this.setarProjeto();
        this.setarRubrica();
        this.setarSubrubrica();
        this.setarGrupo();
        this.dataInicio = this.filtros.dataInicio;
        this.dataFim = this.filtros.dataFim;

        this.$validator
          .validateAll()
          .then(valido => {
            if (!valido) throw new Error("validacao");
            
            $('#gerar').button('loading');

            return relatorioServico.lancamentosProjeto(this.filtros)
          })
          .then(resultado => {
            let total = resultado.lancamentos.length ? resultado.lancamentos.length : 0;

            $('#gerar').button('reset');

            if (total === 0) {
              this.$swal('', 'Nenhum resultado encontrado.', 'info');
            } else {
                this.relatorio = resultado.lancamentos;

                this.$nextTick(() => {
                  $('html, body').animate({
                    scrollTop: $('#relatoriobody').offset().top
                  }, 800);
                });
            }
          })
          .catch(erro => {
            $('#gerar').button('reset');

            if (erro.status === 422) {
              this.$swal('', erro.body.message, 'info');
            } else {
              this.$mensagemErro(erro, 'Erro ao gerar relatório.');
            }
          });
      },
      gerarExcel() {
        this.relatorio = {};
        this.setarProjeto();
        this.setarRubrica();
        this.setarSubrubrica();
        this.setarGrupo();
        this.dataInicio = this.filtros.dataInicio;
        this.dataFim = this.filtros.dataFim;
        
        this.$validator
          .validateAll()
          .then(valido => {
            if (!valido) throw new Error("validacao");
            
            $('#gerar-excel').button('loading');

            return relatorioServico.lancamentosProjetoExcel(this.filtros)
          })
          .then(arquivo => {
            $('#gerar-excel').button('reset');
            
            if (arquivo === '') {
              this.$swal('', 'Nenhum resultado encontrado.', 'info');
            } else {
              arquivo.download();
            }
          })
          .catch(erro => {
            $('#gerar-excel').button('reset');

            this.$mensagemErro(erro, 'Erro ao gerar relatório.');
          });
      },
      setarProjeto() {
        const idProjeto = this.filtros.idProjeto;

        this.projeto = idProjeto ? this.projetos.find(projeto => projeto.idProjeto == idProjeto) : null; 
      },
      setarRubrica() {
        const idRubrica = this.filtros.idRubrica;

        this.rubrica = idRubrica ? this.rubricas.find(r => r.id == idRubrica) : null;
      },
      setarSubrubrica() {
        const idSubrubrica = this.filtros.idSubrubrica;

        this.subrubrica = idSubrubrica ? this.subrubricas.find(s => s.id == idSubrubrica) : null;
      },
      setarGrupo() {
        const idGrupo = this.filtros.idGrupo;

        this.grupo = idGrupo ? this.grupos.find(grupo => grupo.idGrupo == idGrupo) : null;
      },
      formaPagamento(tipo) {
        switch (tipo) {
          case 0:
            return 'Cheque';
            break;
          case 1:
            return 'Boleto';
            break;
          case 2:
            return 'Dep. cheque';
            break;
          case 3:
          case 4:
          case 7:
            return 'Depósito';
            break;
          case 5:
            return 'Boleto';
            break;
          case 6:
            return 'Ordem pgto';
            break;
          default:
            return '---';
            break;
        }
      },
    },
    computed: {
      projetoSelecionado() {
        const idProjeto = this.filtros.idProjeto;

        return idProjeto ? this.projetos.find(projeto => projeto.idProjeto == idProjeto) : {};
      },
    },
    mounted() {
      this.$root.tituloDaPagina = `Relatório de Lançamentos Financeiros - Projetos`;
      this.$root.botaoAcaoTexto = 'Imprimir relatório';
      this.$root.botaoAcaoIcon = 'fa-print';
      this.$root.botaoAcaoLink = '';

      this.$root.botaoRetrocederMostrar = false;
      this.$root.botaoRetrocederRota = '';

      this.$events.on('botaoAcao', function() {
        window.print();
      });

      this.listaDeProjetos();
      this.listaDeGrupos();
      this.listaDeRubricas();
      this.listaDeSubrubricas();

      const _this = this;

      //$('.datepicker input').attr('readonly', '');

      $('#projeto').select2({
        theme: "bootstrap",
        placeholder: "Selecione...",
        language: "pt-BR"
      })
      .change(function(e) {
        _this.$set(_this.filtros, 'idProjeto', this.value);

        _this.filtros.idRubrica = '';
        _this.filtros.idSubrubrica = '';

        _this.listaDeRubricas();
        _this.listaDeSubrubricas();
      });
    },
    beforeDestroy() {
      this.$events.off('botaoAcao');
    },
  }
</script>

<template>
  <div :class="['wrapper wrapper-content animated', $root.animacaoPadrao]">
    <form class="hidden-print" @submit.prevent="gerar">

      <div class="ibox float-e-margins">
        <div class="ibox-content">

          <div class="row">
            <div class="col-sm-6">
              <div class="form-group required" :class="{'has-error': errors.has('dataInicio')}">
                <label class="control-label">Período</label>

                <datepicker id="dataInicio"
                            v-mascara="'data-mask'"
                            v-model="filtros.dataInicio"
                            format="dd/MM/yyyy"
                            placeholder="  /  /     "
                            lang="pt-BR">
                </datepicker>

                <p class="text-danger" v-show="errors.has('dataInicio')">{{ errors.first('dataInicio') }}</p>
              </div>
            </div>

            <div class="col-sm-6">
              <div class="form-group" :class="{'has-error': errors.has('dataFim')}">
                <label class="control-label">&nbsp; &nbsp;</label>

                <datepicker id="dataFim"
                            v-mascara="'data-mask'"
                            v-model="filtros.dataFim"
                            format="dd/MM/yyyy"
                            placeholder="  /  /     "
                            lang="pt-BR">
                </datepicker>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12">
              <div class="form-group" :class="{'has-error': errors.has('projeto')}">
                <label class="control-label" for="projeto">Projeto</label>

                <select id="projeto"
                        class="form-control"
                        v-model="filtros.idProjeto"
                        data-vv-name="projeto">
                  <option value="">Selecione...</option>
                  <option value="0">Todos</option>
                  <option :value="projeto.idProjeto" v-for="(projeto, index) in projetos">{{ projeto.nomeProjeto }}</option>
                </select>

                <p class="text-danger" v-show="errors.has('projeto')">{{ errors.first('projeto') }}</p>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12">
              <div class="form-group" :class="{'has-error': errors.has('grupo')}">
                <label class="control-label" for="grupo">Grupo</label>

                <select id="grupo"
                        class="form-control"
                        v-model="filtros.idGrupo"
                        data-vv-name="projeto">
                  <option value="">Selecione...</option>
                  <option value="0">Todos</option>
                  <option :value="grupo.idGrupo" v-for="(grupo, index) in grupos">{{ grupo.nomeGrupo }}</option>
                </select>

                <p class="text-danger" v-show="errors.has('grupo')">{{ errors.first('grupo') }}</p>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12">
              <div class="form-group">
                <label class="control-label" for="rubrica">Rubrica</label>

                <select id="rubrica"
                        class="form-control"
                        v-model="filtros.idRubrica"
                        @change="listaDeSubrubricas">
                  <option value="">Selecione...</option>
                  <option value="0">Todos</option>
                  <option :value="rubrica.id" v-for="rubrica in rubricas">{{ rubrica.nome }}</option>
                </select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12">
              <div class="form-group">
                <label class="control-label" for="subrubrica">Subrubrica</label>

                <select id="subrubrica"
                        class="form-control"
                        v-model="filtros.idSubrubrica">
                  <option value="">Selecione...</option>
                  <option value="0">Todos</option>
                  <option :value="subrubrica.id" v-for="subrubrica in subrubricas">{{ subrubrica.nome }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <button 
                id="gerar"
                type="button" 
                class="btn btn-primary" 
                @click="gerar"
                data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando relatório...">
              <i class="fa fa-line-chart"></i> 
              Gerar relatório
            </button>
            <button 
                id="gerar-excel"
                type="button" 
                class="btn btn-primary" 
                @click="gerarExcel"
                data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando relatório...">
              <i class="fa fa-table"></i> 
              Gerar relatório em excel
            </button>

            <tela-cheia
              texto="Visualizar em tela cheia"
              icone="arrows-alt"
              v-if="relatorio.length > 0">
            </tela-cheia>
          </div>
        </div>
      </div>
    </form>

    <cabecalho-relatorio titulo="Relatório de Lançamentos Financeiros - Projetos" borda=""></cabecalho-relatorio>

    <div class="row" v-if="relatorio.length > 0" id="relatorio">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">

            <div class="table-responsive">
            
              <table class="table relatorio table-bordered">
                <thead>
                  <tr>
                    <th>Código</th>
                    <th>Projeto</th>
                    <th>Data</th>
                    <th>CPF/CNPJ</th>
                    <th>Histórico</th>
                    <th>Meta\etapa</th>
                    <th>Rubrica</th>
                    <th>Subrubrica</th>
                    <th>Forma pgto.</th>
                    <th>Documento Receber/Pagar</th>
                    <th class="text-center">Valor (R$)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(lancamento, index) in relatorio">
                    <td>{{ lancamento.idLancamento }}</td>
                    <td>{{ lancamento.nomeProjeto }}</td>
                    <td>{{ lancamento.data | formatarData }}</td>
                    <td>{{ lancamento.cpfCnpj || '---' }}</td>
                    <td>{{ lancamento.historico }} - {{ lancamento.complemento ? ` - ${lancamento.complemento}` : '' }}</td>
                    <td>{{ lancamento.metaEtapa || '---' }}</td>
                    <td>{{ lancamento.nomeRubrica || '---' }}</td>
                    <td>{{ lancamento.nomeSubrubrica || '---' }}</td>
                    <td>{{ formaPagamento(lancamento.formaPagamento) }}</td>
                    <td>{{ lancamento.documentoReceberPagar || '---' }}</td>
                    <td :class="['text-right', lancamento.creditoDebito === 1 ? 'text-primary' : 'text-danger']">{{ lancamento.creditoDebito === 1 ? '' : '-' }} {{ lancamento.valor | formatarNumero }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/relatorio/componentes/LancamentosProjetos.vue